import { useRouter } from 'next/router';
import React from 'react';
import { AppointmentCard } from './AppointmentCard';

const Appointment = () => {
  const router = useRouter();

  return (
    <div className="flex flex-col px-8 mt-12 items-center align-center w-full" style={{ height: '90vh' }}>
      <div className="m-5" style={{ width: '500px' }}>
        <AppointmentCard appointmentId={router.query.aid && router.query.aid.toString()} />
      </div>
    </div>
  );
};

export default Appointment;
